var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMn = function SvgMn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4800 2400"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f9cf02"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4272f",
    d: "M0 0h960v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#015197",
    d: "M320 0h320v480H320z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 164,
    r: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 144,
    r: 48,
    fill: "#c4272f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 152,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 92a20 20 0 0 0 40 0c0-8-5-9-5-12s3-7-3-12c3 5-2 6-2 11s2 5 2 9a4 4 0 0 1-8 0c0-4 4-8 4-14s-1-8-4-13-8-9-4-13c-6 2-3 10-3 15s-4 8-4 14 3 7 3 11a4 4 0 0 1-8 0c0-4 2-4 2-9s-5-6-2-11c-6 5-3 9-3 12s-5 4-5 12M72 216v192h40V216Zm136 0v192h40V216Zm-88 32v16h80v-16Zm0 112v16h80v-16Zm0-144h80l-40 24Zm0 168h80l-40 24Z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#c4272f",
    strokeWidth: 24
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1560,
    r: 212
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M800 1348a106 106 0 0 1 0 212 106 106 0 0 0 0 212"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#c4272f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1454,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1666,
    r: 40
  }))));
};
export default SvgMn;